export default "__VITE_ASSET__BKT9jL3U__"